import { flatMap, keyBy, map } from 'lodash'
import { createSelector } from '@reduxjs/toolkit'

export const
  allGroups = state => (state.groups?.groups || []),

  allFeeds = createSelector(allGroups, groups => flatMap(groups, "feeds")),

  // temporary for blockly
  allFeedsWithGroupInfo = createSelector(allGroups, groups =>
    flatMap(groups, group =>
      map(group.feeds, feed => ({
        id: feed.id,
        name: feed.name,
        groupName: group.name,
        key: feed.key
      }))
    )
  ),

  feedsByKey = createSelector(allFeeds, feeds => keyBy(feeds, "key")) // { [feed.key]: feed, ... }
